import React, { useEffect, useState } from 'react'
import {Accordion, Card, Form, Button, Row, Col, ListGroup} from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from '../../store'
import { applyDiscountCode, setPaymentMethod } from '../../store/paymentData'
import { onlinePaymentTypeNames, OnlinePaymentTypes, PaymentConfigurations } from '../../store/program/interfaces'
import { DebitForm } from './DebitForm'
import { AddPaymentValidatorFunc, RemovePaymentValidatorFunc, Validator } from '../../hooks/validators'
import { useForm } from 'react-hook-form'
import { updateRegistration } from '../../store/registrations/registrations'
import { IRegistration } from '../../store/registrations/interfaces'
import { useAppDispatch } from '../../hooks'
import DiscountCodeItem from './DiscountCodeItem'


const DiscountCodeInput = (props: {
  registrations: IRegistration[]
}) => {
  const dispatch = useAppDispatch()
  const registrations = useSelector(
    (state: RootState) => state.registrations.list,
  )
  const {
    basic_fee,
    payment_configuration: { smallprint },
  } = useSelector((state: RootState) => state.program.data)

  const { loadedViaCode } = useSelector((state: RootState) => state.misc)
  const { discountCodes } = useSelector((state: RootState) => state.paymentData)

  const { register, trigger, getValues, setValue, setError, clearErrors, formState: { errors } } = useForm<{
    discount_code: string
  }>()

  useEffect(() => {
    if(getValues()['discount_code']) {
      if (discountCodes.find((d) => d.code.trim() === getValues()['discount_code'])) {
        setValue('discount_code', '');
        clearErrors();
      } else {
        setError('discount_code', {
          type: 'manual',
          message: 'Rabattcode ist nicht gültig.',
        });
      }
    }
  },[discountCodes])

  return (
    <div className="mt-3">
      <hr/>
      {discountCodes.length > 0 &&
        <>
          <h5>Aktive Rabattcodes</h5>
          <ListGroup variant="flush">
            {discountCodes.map((d) => (
              <DiscountCodeItem discountCode={d} key={d.code} />
            ))}
          </ListGroup>
        </>
      }
      <Form.Group>
        <Form.Label>
          <br />
          <small className='font-weight-bold'>Haben Sie einen Rabattcode?</small>
        </Form.Label>
        <Row>
          <Col xs={8}>
            <Form.Control
              {...register('discount_code', {})}
              //id={`specialNotes-${registration.event.event_id}`} TODO: necessary? why?
              placeholder='Rabattcode...'
              isInvalid={!!errors.discount_code}
              aria-label='Rabattcode eingeben'
            />
            <Form.Control.Feedback type='invalid'>
              {errors.discount_code && errors.discount_code.message}
            </Form.Control.Feedback>
          </Col>
          <Col xs={4}>
            <Button onClick={async (e) => {
              const code = getValues()['discount_code'].trim()
              if (code) {
                const isValid = await dispatch(
                  applyDiscountCode(getValues()['discount_code'].trim(), 'add')
                )
                if(isValid) {
                  setValue('discount_code', '')
                  clearErrors('discount_code')
                } else {
                  setError('discount_code', { type: 'custom', message: 'Ungültiger Rabattcode' });
                }
              }
            }}>Anwenden</Button>
          </Col>
        </Row>
      </Form.Group>
      <Row>
      </Row>
    </div>
  )
}

export default DiscountCodeInput
